<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style lang="scss">
@import '../node_modules/bootstrap/scss/bootstrap.scss';
@import 'sass/_settings';

#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.sections {
  height: 100vh;
  min-height: 750px;

  padding: 100px 0;

  -webkit-background-size: cover;
  background-size: cover;
  background-position: center center;

  p {
    color: $main-color;
    font-size: 1em;
    font-weight: 500;
    margin-bottom: 5px;
  }
}

.title-img {
  height: 35px;
}

hr {
  border-top: 1.5px solid #043c53;
}

@media (min-width: 769px) {
  hr {
    width: 80%;
  }
}

@media (max-width: 768px) {
  .sections {
    min-height: 900px;
  }
}

@media (max-width: 576px) {
  .sections {
    padding: 50px 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/App.vue